import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { CommunicationStatsDto } from './dto/communication-stats.dto'

export class EventSourcesRepository extends BaseRepository<null> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'eventsources', token, cache)
    }

    async getAllFromEventSource(
        from: Date,
        to: Date,
        events: string[],
        ignoreComunication: boolean = false,
        onlyLastEvent: boolean = false,
    ) {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl +
                '/eventsources/external-date?from=' +
                from +
                '&to=' +
                to +
                '&events=' +
                events +
                '&ignoreComunication=' +
                ignoreComunication +
                '&onlyLastEvent=' +
                onlyLastEvent +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    /**
     * Números já agregados de comunicação (por dia e por hora), para o dashboard.
     * Diferente do getAllFiltered, que devolve uma linha por mensagem, aqui vem ~N linhas
     * para N dias — a agregação acontece no events-api.
     */
    async getCommunicationStats(params: {
        from: string | Date
        to: string | Date
        sources?: string[]
        tzOffsetMinutes?: number
        channelId?: string
    }): Promise<CommunicationStatsDto> {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== undefined && params[key] !== null) queryString += key + '=' + params[key] + '&'
        }
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/eventsources/communication-stats' + queryString + 'token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getAllFiltered(params: any, useCacheIfNewerThanThisInSeconds: number = 0) {
        let queryString = '?'
        for (const key in params) {
            if (params[key]) queryString += key + '=' + params[key] + '&'
        }
        const url =
            this.config.eventApiUrl +
            '/eventsources/filtered/' +
            queryString +
            'token=' +
            this.resolvedToken
        if (useCacheIfNewerThanThisInSeconds > 0) {
            const cached = this.resolvedCache.get(url, useCacheIfNewerThanThisInSeconds)
            if (cached) return cached
        }

        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') {
            this.resolvedCache.set(url, json, this.config.eventApiUrl + '/eventsources/filtered/')
            return json
        }
        throw message
    }
}
